{
  "$schema": "http://json.schemastore.org/package",
  "name": "verdaccio-github-oauth-ui",
  "version": "7.1.5",
  "keywords": [
    "authentication",
    "github",
    "login",
    "npm",
    "oauth",
    "package",
    "private",
    "registry",
    "verdaccio",
    "verdaccio-auth",
    "verdaccio-auth-plugin",
    "verdaccio-plugin"
  ],
  "homepage": "https://github.com/n4bb12/verdaccio-github-oauth-ui/blob/master/README.md",
  "bugs": "https://github.com/n4bb12/verdaccio-github-oauth-ui/issues",
  "repository": "github:n4bb12/verdaccio-github-oauth-ui",
  "license": "MIT",
  "author": "Abraham Schilling",
  "main": "dist/server/index.js",
  "bin": "dist/cli/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "bash run build",
    "clean": "bash run clean",
    "cli": "bash run cli",
    "cli:login": "bash run cli-login",
    "cli:publish": "bash run cli-publish",
    "cli:whoami": "bash run cli-whoami",
    "copy": "bash run copy",
    "coverage": "vitest --coverage",
    "dev": "run-s update start",
    "docker": "bash run docker_",
    "fix": "run-s format typecheck",
    "format": "prettier --write \"**/*.{ts,js,css,scss,html,json}\"",
    "format:check": "prettier --check \"**/*.{ts,js,css,scss,html,json}\"",
    "prepack": "bash run clean && bash run build",
    "start": "verdaccio -c verdaccio.yaml",
    "test": "vitest",
    "typecheck": "bash run typecheck",
    "update": "run-s prepack copy",
    "watch": "nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \"bun dev\""
  },
  "dependencies": {
    "@octokit/oauth-methods": "^6.0.2",
    "@octokit/request": "^10.0.8",
    "@verdaccio/core": "^8.0.0-next-8.31",
    "@verdaccio/url": "^13.0.0-next-8.31",
    "dotenv": "^17.3.1",
    "express": "^4.22.1",
    "lodash": "^4.17.23",
    "memory-cache": "^0.2.0",
    "minimist": "^1.2.8",
    "octokit": "^5.0.5",
    "open": "^11.0.0",
    "ow": "^3.1.1",
    "picocolors": "^1.1.1",
    "query-string": "^9.3.1",
    "undici": "^7.22.0"
  },
  "devDependencies": {
    "@parcel/config-default": "^2.16.4",
    "@parcel/transformer-typescript-tsc": "^2.16.4",
    "@types/express": "^4.17.25",
    "@types/lodash": "^4.17.24",
    "@types/memory-cache": "^0.2.6",
    "@types/minimist": "^1.2.5",
    "@types/node": "^24.12.0",
    "@types/query-string": "^6.3.0",
    "@verdaccio/types": "^13.0.0-next-8.11",
    "@vitest/coverage-v8": "^4.0.18",
    "browserslist": "^4.28.1",
    "core-js": "^3.48.0",
    "nodemon": "^3.1.14",
    "npm-run-all2": "^8.0.4",
    "parcel": "^2.16.4",
    "prettier": "^3.8.1",
    "process": "^0.11.10",
    "release-it": "^19.2.4",
    "timekeeper": "^2.3.1",
    "type-fest": "^5.4.4",
    "typescript": "^5.9.3",
    "verdaccio": "^6.3.1",
    "verdaccio-htpasswd": "^13.0.0-next-8.31",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "^4.0.18"
  },
  "peerDependencies": {
    "verdaccio": ">=6"
  },
  "engines": {
    "node": ">=20"
  },
  "publishConfig": {
    "registry": "https://registry.npmjs.org/"
  },
  "targets": {
    "client": {
      "source": "src/client/verdaccio-6.ts",
      "distDir": "dist/client",
      "context": "browser",
      "includeNodeModules": true
    },
    "server": {
      "source": "src/server/index.ts",
      "distDir": "dist/server",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false,
      "isLibrary": true
    },
    "cli": {
      "source": "src/cli/index.ts",
      "distDir": "dist/cli",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false
    }
  }
}
